<template>
  <div>
    <EditButton
      :disabled="!$atividades.permissoes.includes(14)"
      @func="showModalEditarArea = true"
    ></EditButton>
    <SideBar
      title="Editar area"
      @hide="cancelar()"
      :active="showModalEditarArea"
      size="small"
      textSucces="Atualizar"
      icon="edit"
      :disabled="!$atividades.permissoes.includes(15)"
      :item="area"
      @excluir="exluirArea()"
      @status="mudarStatusArea()"
      @success="submitForm()"
    >
      <div slot="body">
        <vs-row class="mb-4" vs-type="flex" vs-w="12">
          <vs-col vs-w="12">
            <vs-input
              class="inputx w-full"
              label-placeholder="Nome"
              v-validate="'required'"
              name="nome"
              v-model="area.nome"
            />
            <span class="text-danger text-sm" v-show="errors.has('nome')">{{
              $validators.empty
            }}</span>
          </vs-col>
        </vs-row>
      </div>
    </SideBar>
  </div>
</template>

<script>
import components from "@/components/default/exports.js";

export default {
  props: { area: Object },
  data() {
    return {
      showModalEditarArea: false,
      originalData: {},
      error: false,
    };
  },
  mounted() {
    this._beforeEditingCache = Object.assign({}, this.area);
    this.originalData = this.area;
  },
  methods: {
    async submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.editarArea();
        } else {
          this.error = true;
          this.$vs.notify(this.$notify.Empty);
        }
      });
    },
    async editarArea() {
      this.$vs.loading();
      try {
        const res = await this.$http.put(`area/${this.area.id}`, this.area);
        let logData = {
          id_colaborador: localStorage.getItem("id"),
          funcao: "atualizar",
          setor: "comercial",
          ip: window.localStorage.getItem("ip"),
          texto: "Edição da área N°" + res.id,
        };
        await this.$logger(logData);

        this.$vs.notify(this.$notify.Success);
        this.showModalEditarArea = false;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      } finally {
        this.$vs.loading.close();
      }
    },
    async mudarStatusArea() {
      this.$vs.loading();
      try {
        const res = await this.$http.put(`area/${this.area.id}`, {
          lixeira: !this.area.lixeira,
        });
        let logData = {
          id_colaborador: localStorage.getItem("id"),
          funcao: "atualizar",
          setor: "comercial",
          ip: window.localStorage.getItem("ip"),
          texto: "Mudar status da área N°" + res.id,
        };
        await this.$logger(logData);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      } finally {
        this.$vs.loading.close();
        this.$emit("update");
      }
    },
    async exluirArea() {
      this.$vs.loading();
      try {
        await this.$http.delete(`area/${this.area.id}`);
        let logData = {
          id_colaborador: localStorage.getItem("id"),
          funcao: "excluir",
          setor: "comercial",
          ip: window.localStorage.getItem("ip"),
          texto: "Exclusão da área N°" + this.area.id,
        };
        await this.$logger(logData);
        this.$vs.notify(this.$httpErrors.success);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      } finally {
        this.$vs.loading.close();
        this.$emit("update");
      }
    },
    cancelar() {
      Object.assign(this.area, this._beforeEditingCache);
      this.originalData = this._beforeEditingCache = null;
      this.showModalEditarArea = false;
    },
  },
  components: components,
};
</script>

<style></style>
